import { Campaign } from '@/types/campaign.types';
import { store } from '@/store/main';
import { Get } from '../helpers';

const FetchCampaigns = async (): Promise<Campaign[]> => {
  const projectId = store.getState().project.workingProject?.event;
  const query = projectId ? `?filter[project_id]=${projectId}` : '';
  const results: (Omit<Campaign, 'thumbnailUrl'> & { preview_url?: string })[] = await Get({
    path: `/v3/admin/auth/campaigns${query}`,
  });
  return results.map(({ preview_url, ...rest }) => ({ ...rest, thumbnailUrl: preview_url }));
};

export default FetchCampaigns;
